import { Box } from '@user-portal/wikr-components';
import styled from 'styled-components';

import { mediaQueries } from 'theme/mediaQueries';

import ScanIconImg from 'assets/img/scan-icon-phone.svg';

export const DownloadWrapper = styled(Box)`
    max-width: 311px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
`;

export const DownloadDescription = styled(Box)`
    ${mediaQueries.tabletLandscape} {
        display: none;
    }
`;

export const ScanIcon = styled(ScanIconImg)<{ $maxWidth: number; $mb: number }>`
    ${({ $mb }) => Number.isInteger($mb) && `margin-bottom: ${$mb}px;`};
    width: 100%;
    margin-left: auto;
    margin-right: auto;
`;

export const IconWrapper = styled.div`
    margin-bottom: 20px;
    max-width: 100%;
    display: flex;
    justify-content: center;
`;
